import { VideoEditor } from '../components/VideoEditor';

export default function VideoCommercialPage() {
  return <VideoEditor style="commercial" />;
}
